module.exports = __webpack_public_path__ + "static/media/boat-img-28.7c81cd73.jpg";